import { State } from "./state";
import { GetterTree } from "vuex";

import { getError, getIsLoading, getDataItem, getSuccess, getDataList, getTotal, getId } from "@/store/Crud/functions/getters";

export const getSelectedStudent = (state: State) => state.selectedStudent;
export const getRegistrationProcessStatuses = (state: State) => state.registrationProcessStatuses;

export default <GetterTree<State, any>>{
  getError,
  getIsLoading,
  getDataItem,
  getSuccess,
  getDataList,
  getTotal,
  getId,
  getSelectedStudent,
  getRegistrationProcessStatuses,
};
